// imports
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import Header from '../../header';
import { ICON } from '../../../assets';
import Utils from '../../../common/utils';
import { ROUTES } from '../../../constants';
import ItemDropdown from '../../../atoms/dropdown/item';
import PrimaryButton from '../../../atoms/button/primary';
import AccountDropdown from '../../../atoms/dropdown/account';
import { selectConfig, selectUserQuests } from '../../../repositories/store/slices';

// interfaces / types / consts
interface Props {
  items: string[];
  backButtonText?: string;
  backBtnClickedCB?: () => void;
}

// exports
export default function GameHeader(props: Props): JSX.Element {
  const {
    items, backBtnClickedCB, backButtonText
  } = props;
  const accDropdownIsSM = items!.length > 2;
  // hooks configuration
  const { world } = useSelector(selectConfig);
  const { startId, claimId } = useSelector(selectUserQuests);
  const disabled = Boolean(startId) || Boolean(claimId);
  return (
    <Header content={(
      <>
        <div>
          {(!Utils.dom.isMap() || backBtnClickedCB)
            && (
              <div className={clsx('back', Utils.dom.isMap() && 'forward')}>
                <PrimaryButton
                  size="sm"
                  className="back-btn"
                  disabled={disabled}
                  leftIcon={ICON.DROPDOWN_ARROW}
                  onClick={() => { if (backBtnClickedCB) { backBtnClickedCB(); } }}
                />
                <div className="back-text">{backButtonText || world.name}</div>
              </div>
            )}
        </div>
        <div className="right-container">
          {items!.length > 0 && (<ItemDropdown items={items} disabled={disabled} />)}
          <div className={clsx('d-flex', 'align-items-center', accDropdownIsSM ? 'right-section-xl' : 'right-section')}>
            <AccountDropdown profileLink={ROUTES.HERO_COLLECTION} disabled={disabled} />
          </div>
        </div>
      </>
    )}
    />
  );
}

// default props
GameHeader.defaultProps = { backBtnClickedCB: undefined, backButtonText: '' };
